import axios from '../../localAxios';
import { WorkspaceRole } from '../getWorkspaceMembers';
import { workspaceCodeURL } from '../workspacesURLs';

export interface WorkspaceCode {
  code: string;
}

export interface GetWorkspaceCodeParams {
  workspaceId: string;
  workspaceRole: WorkspaceRole;
}

export async function getWorkspaceCode({
  workspaceId,
  workspaceRole,
}: GetWorkspaceCodeParams) {
  const url = workspaceCodeURL({
    workspaceId: workspaceId,
    workspaceRole: workspaceRole,
  });
  const response = await axios.get<WorkspaceCode>(url.href);
  return response.data;
}
